module.exports = __webpack_public_path__ + "static/img/blue-on-light@3x.9f75731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stripe/Stripe-Connect-button/Stripe Connect button/PNG button - blue/blue-on-light@3x.png
// module id = csq3
// module chunks = 0